import {GET_TOPIC_COLLECTION, GET_POPULAR_COLLECTION, HOME_SECTIONS_LOADER, RESET_HOME_SEARCH_RESULT} from '../../constants/reducerTypes';

const initialState = {};
const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_POPULAR_COLLECTION:
      return {
        ...state,
        popularCollection: action.payload.results,
        popularTotalRows: action.payload.popularTotalRows,
        searchLoader: false
      };
    case GET_TOPIC_COLLECTION:
      return {
        ...state,
        topicCollection: action.payload,
        searchLoader: false
      };
    case HOME_SECTIONS_LOADER:
      return {
        ...state,
        searchLoader: true
      };
    case RESET_HOME_SEARCH_RESULT:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export default homeReducer;
